module.exports = __webpack_public_path__ + "b548e64e9d6def9c66a68272bc5fbc3f.png";